export default class BodyApi {
  static setImage(files) {
    return (dispatch) => {
      dispatch({ type: 'SET_IMAGE', file: files });
    };
  }
}
